module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "material-design-icon vector-rectangle-icon",
    attrs: {
      "aria-hidden": _vm.decorative,
      "role": "img",
      "aria-label": _vm.title
    }
  }, [_c('svg', {
    staticClass: "material-design-icon__svg",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": _vm.fillColor
    }
  }, [_c('title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2,4H8V6H16V4H22V10H20V14H22V20H16V18H8V20H2V14H4V10H2V4M16,10V8H8V10H6V14H8V16H16V14H18V10H16M4,6V8H6V6H4M18,6V8H20V6H18M4,16V18H6V16H4M18,16V18H20V16H18Z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32d819d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-material-design-icons/vector-rectangle.vue
// module id = 1048
// module chunks = 1